export default {
  'meta': {
    'langName': 'Serbian',
    'lang': 'Srpski'
  },
  'title': 'POVLAČENJE PROIZVODA BASKETBALL HOOP B900 BOX NBA TARMAK',
  'description': 'Pozdrav!\n\nNedavno ste kupili košarkaški koš Tarmak B900 BOX NBA i zahvaljujemo Vam na kupovini.\n\nKao deo naše trajne predanosti kvalitetu i sigurnosti proizvoda, košarkaški tim DECATHLONA je uočio potencijalni rizik od vertikalnog pada štapa ako se ukloni ručica za podešavanje visine, a proizvodom se zatim rukuje ili se koristi.\n\nLjubazno Vas molimo da odgovorite na nekoliko pitanja, kako bismo mogli da Vam pružimo odgovarajuće sigurnosno rešenje za Vaš proizvod.\n\nIzvinjavamo se zbog neprijatnosti i zahvaljujemo Vam na ukazanom poverenju.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Prvo, molimo Vas da potvrdite svoj e-mail i državu prebivališta:'
  },
  'fields': {
    'country': 'Država',
    'address': 'E-mail',
    'email': 'E-mail',
    'phonePrefix': 'Pozivni broj',
    'phone': 'Telefonski broj',
    'validations': {
      'phoneOrEmail': 'Molimo Vas da navedite barem e-mail ili broj telefona.',
      'email': 'Molimo, unesite važeću adresu',
      'phone': 'Molimo, unesite važeći broj telefona'
    },
    'firstName': 'Prezime',
    'lastName': 'Ime',
    'deliveryAddress': 'Adresa za dostavu paketa',
    'additionalAddress': 'Dodatne pojedinosti o adresi',
    'city': 'Grad',
    'zip': 'Poštanski broj',
    'choose': 'Izaberite',
    'required': 'Ovo polje je obavezno'
  },
  'ownerCheck': {
    'title': 'Da li još uvek posedujete jedan ili više košarkaških koševa B900 BOX NBA?'
  },
  'yes': 'DA',
  'no': 'NE',
  'ownerChanged': {
    'title': 'Da li imate kontakt podatke trenutnog vlasnika?',
    'confirmation': 'Poštovani,\n\nHvala Vam na učestvovanju u ovoj inicijativi.\n\nIzvinjavamo se zbog neprijatnosti i zahvaljujemo Vam na ukazanom poverenju.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Molimo Vas da navedete broj košarkaških koševa koje imate, zavisno od vrste ugrađene ručice.',
    'descriptionRed': 'Košarkaški koš sa uklonjivom crvenom ručicom',
    'descriptionBlack': 'Košarkaški koš sa fiksnom crnom ručicom',
    'quantity': 'Količina',
    'notConcerned': 'Poštovani,\n\nHvala Vam što učestvujete u ovoj inicijativi.\n\nMožete biti sigurni da Vaš košarkaški koš Tarmak B900 BOX NBA nije pogođen postupkom povlačenja. Siguran je za korišćenje.\n\nIzvinjavamo se zbog eventualnih neprijatnosti i zahvaljujemo Vam na ukazanom poverenju.\n\nDECATHLON',
    'concernedProductQuantity': 'Količina neusklađenih proizvoda:',
    'concernedProductLabel': 'Neusklađen proizvod:',
    'confirmation': 'Hvala Vam što ste ispunili ovaj obrazac. Vaš zahtev je uspešno zabeležen.\n\nPoslaćemo Vam broj za praćenje Vaše pošiljke u najkraćem mogućem roku (putem FandiWeba).\n\nŽelimo Vam prijatan dan.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Popravka uz Vaše učestvovanje',
    'description': 'Otkrili smo rizik od vertikalnog pada štapa ako se ručica ukloni, a proizvodom se rukuje ili se koristi, na određenim košarkaškim koševima TARMAK B900 BOX NBA, broj artikla 4239136.\nNa temelju Vašeg odgovora, čini se da je Vaš proizvod pogođen ovim rizikom.\n\nZato Vas molimo da odmah prestanete da ga koristite i nudimo Vam pomoć u podešavanju ručice, kako biste mogli sigurno koristiti svoj proizvod.\nBudite uvereni, ova popravka ne zahteva posebnu stručnost - sve je jasno objašnjeno u videu i uputstvima za upotrebu u nastavku:\n',
    'videoLink': 'Link na video',
    'docLink': 'Link na tekst',
    'callToAction': 'Kliknite ovde kako biste dobili svoj besplatan komplet za popravku',
    'warranty': 'Ceo proces je pokriven našom 5-godišnjom garancijom.'
  },
  'repairRequest': {
    'title': 'Molimo, unesite sledeće podatke, kako bismo Vam poslali besplatan komplet na adresu po Vašem izboru:'
  },
  'form': {
    'submit': 'Sledeće'
  },
  'status': 'Translation validated by COUNTRY'
} as const
